import { DateRangeValue } from 'features/date-range-selection/dateRangeSlice';
import { Segment, SegmentFilter } from '../segment-controls.types';
import { AdvancedReportsQueryCategories } from 'features/advanced-reports/constants/advanced-reports-query-categories';
import {
  AdvancedReportQueryRequestDto,
  GetAdvancedReportQuerySegment,
  GetAdvancedReportQuerySegmentFilter,
  GetAdvancedReportQuerySegmentFilterValue
} from 'features/advanced-reports/advanced-reports.types';
import { toLocalIso } from 'common/utils/date-helpers';
import { InsightTypes } from 'features/insights/constants/insight-types';
import {
  GetInsightQuerySegmentFilter,
  GetInsightsQuerySegment,
  GetInsightsQuerySegmentFilterValue,
  InsightQueryRequestDto
} from 'features/insights/types/insights.types';

export const createAdvancedReportRequest = (
  siteId: string,
  queryCategory: AdvancedReportsQueryCategories,
  currencyCode: string,
  attributionModelName: string,
  segments: Segment[],
  segmentFilters: SegmentFilter[],
  dates: DateRangeValue
): AdvancedReportQueryRequestDto => {
  const segmentRequests = segments.map((segment) =>
    createAdvancedReportSegmentRequest(segment, segmentFilters)
  );

  const result: AdvancedReportQueryRequestDto = {
    siteId,
    queryCategory,
    currencyCode,
    attributionModelName,
    segmentRequests,
    startDate: toLocalIso(dates.startDate),
    endDate: toLocalIso(dates.endDate)
  };

  return result;
};

export const createInsightsReportRequest = (
  siteId: string,
  insightType: InsightTypes,
  segments: Segment[],
  segmentFilters: SegmentFilter[],
  dates: DateRangeValue
): InsightQueryRequestDto => {
  const segmentRequests = segments.map((segment) =>
    createInsightSegmentRequest(segment, segmentFilters)
  );

  const result: InsightQueryRequestDto = {
    siteId,
    insightType,
    startDate: toLocalIso(dates.startDate),
    endDate: toLocalIso(dates.endDate),
    segmentRequests
  };

  return result;
};

function createAdvancedReportSegmentRequest(
  segment: Segment,
  segmentFilters: SegmentFilter[]
): GetAdvancedReportQuerySegment {
  const currentSegmentFilters = segmentFilters
    .filter((filter) => filter.segmentId === segment.id)
    .map<GetAdvancedReportQuerySegmentFilter>((filter) => ({
      values: filter.values.map<GetAdvancedReportQuerySegmentFilterValue>(
        (filterValue) => ({
          value: filterValue.value,
          valueOperator: filterValue.valueOperator
        })
      )
    }));

  const request: GetAdvancedReportQuerySegment = {
    segmentId: segment.id,
    order: segment.order,
    segmentType: segment.segmentType,
    segmentCategory: segment.segmentCategory,
    filters: currentSegmentFilters
  };

  return request;
}

function createInsightSegmentRequest(
  segment: Segment,
  segmentFilters: SegmentFilter[]
): GetInsightsQuerySegment {
  const currentSegmentFilters = segmentFilters
    .filter((filter) => filter.segmentId === segment.id)
    .map<GetInsightQuerySegmentFilter>((filter) => ({
      values: filter.values.map<GetInsightsQuerySegmentFilterValue>(
        (filterValue) => ({
          value: filterValue.value,
          valueOperator: filterValue.valueOperator
        })
      )
    }));

  const request: GetInsightsQuerySegment = {
    segmentId: segment.id,
    order: segment.order,
    segmentType: segment.segmentType,
    segmentCategory: segment.segmentCategory,
    filters: currentSegmentFilters
  };

  return request;
}
